import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useAPI } from "components/lib";
import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";
import Axios from "axios";
import "survey-core/defaultV2.min.css";
import { applyStackgoTheme } from "components/survey/stackgo-theme";
import { use } from "chai";

StylesManager.applyTheme("defaultV2");

export function ZendeskSellSettingsView(props) {
  const existingSettingsResponse = useAPI("/api/integration/zendesk-sell");
  const customFieldsResponse = useAPI(
    "/api/integration/zendesk-sell/custom-fields"
  );
  const [booleanCustomFields, setBooleanCustomFields] = useState([]);
  const [dropdownCustomFields, setDropdownCustomFields] = useState([]);
  const [urlCustomFields, setUrlCustomFields] = useState([]);
  const env = process.env.NODE_ENV;
  const navigateToUrl =
    env === "production"
      ? `https://identity.stackgo.io/account`
      : `http://localhost:3000/account`;

  useEffect(() => {
    if (customFieldsResponse.loading === false) {
      const booleanFields = customFieldsResponse?.data
        ?.filter((field) => field.type === "bool")
        .map((field) => ({
          value: field.id,
          text: field.name,
        }));
      const dropdownFields = customFieldsResponse?.data
        ?.filter((field) => field.type === "list")
        .map((field) => ({
          value: field.id,
          text: field.name,
        }));
      const urlFields = customFieldsResponse?.data
        ?.filter((field) => field.type === "url")
        .map((field) => ({
          value: field.id,
          text: field.name,
        }));
      setBooleanCustomFields(booleanFields);
      setDropdownCustomFields(dropdownFields);
      setUrlCustomFields(urlFields);
    }
  }, [customFieldsResponse]);

  function setExistingZendeskSellSettings() {
    if (
      existingSettingsResponse.loading === false &&
      existingSettingsResponse.data !== null
    ) {
      const settings = existingSettingsResponse?.data?.[0];
      survey.setValue("enabled", settings?.enabled);
      survey.setValue("kyc_command_field", settings?.data?.kyc_command_field);
      survey.setValue("kyc_status_field", settings?.data?.kyc_status_field);
      survey.setValue(
        "verification_link_field",
        settings?.data?.verification_link_field
      );
    }
  }
  const json = {
    completedHtml: "<h3>Your changes have been saved.</h3>",
    showQuestionNumbers: "off",
    pages: [
      {
        name: "ZendeskSellSettingsView",
        elements: [
          {
            type: "boolean",
            name: "enabled",
            title: "Enabled",
            isRequired: true,
            defaultValue: false,
          },
          {
            type: "html",
            name: "info",
            html: `<p>Before you can use the Zendesk Sell integration, you need to create custom fields for contacts in Zendesk Sell.
            <br />
            <a href="https://support.zendesk.com/hc/en-us/articles/4408838289562-Creating-and-managing-Sell-custom-fields" target="_blank">Click here for instructions.</a></p>
            <p>The following custom fields are required:</p>
            <ul>
            <li>KYC Command - Boolean</li>
            <li>KYC Status - Single Select</li>
            <li>Verification Link - Link</li>
            </ul>
            `,
          },
          {
            type: "dropdown",
            name: "kyc_command_field",
            title: "KYC Command Custom Field Label",
            choices: booleanCustomFields,
            isRequired: true,
          },
          {
            type: "dropdown",
            name: "kyc_status_field",
            title: "KYC Status Custom Field Label",
            choices: dropdownCustomFields,
            isRequired: true,
          },
          {
            type: "dropdown",
            name: "verification_link_field",
            choices: urlCustomFields,
            title: "Verification Link Custom Field Label",
            isRequired: true,
          },
        ],
      },
    ],
  };

  json.navigateToUrl = navigateToUrl;

  async function saveSurveyResults(url, json) {
    console.log("saveSettings", url, json);
    const response = await Axios.post(url, json);
  }

  const ZendeskSellSettingsAdded = useCallback((sender) => {
    const data = sender.data;
    const q = sender.getQuestionByName("kyc_command_field");
    data.kyc_command_label = q.getDisplayValue(true);
    const q2 = sender.getQuestionByName("kyc_status_field");
    data.kyc_status_label = q2.getDisplayValue(true);
    const q3 = sender.getQuestionByName("verification_link_field");
    data.verification_link_label = q3.getDisplayValue(true);
    console.log("ZendeskSellSettingsAdded", data);
    saveSurveyResults("/api/integration/zendesk-sell", data);
  });

  const survey = new Model(json);
  applyStackgoTheme(survey);
  survey.onComplete.add(ZendeskSellSettingsAdded);
  setExistingZendeskSellSettings();

  return (
    <Fragment>
      <Survey model={survey} />
    </Fragment>
  );
}
